module.exports = __webpack_public_path__ + "img/diilistirio.f7cb8f51.png";